import { useToken, useColor } from "./useToken";
import {themeTools, useColorMode, useTheme} from "native-base";
import { useContrastProps } from "./useContrastProps";

export const useThemeColors = () => {
    const theme = useTheme();
    const colorMode = useColorMode().colorMode;
    const { bg: primary, color: primaryContrastColor } = useContrastProps();
    const [fontFamilyBody, fontFamilyHeading] = useToken("fonts", ["body", "heading"]);
    const [primaryColor, primaryContrast, primaryColorDark, textColor, lightBg, darkBg] = useColor(primary, primaryContrastColor, "primary.600", "dark.100", "coolGray.100", "dark.100");
    const primaryHover = themeTools.transparentize(primary, .1)(theme);
    const textHover = themeTools.transparentize("dark.100", .1)(theme);

    return {
        baseBg: colorMode === "dark" ? darkBg : lightBg,
        colorMode,
        fontFamilyHeading,
        fontFamilyBody,
        primaryColor,
        primaryColorDark,
        primaryContrast,
        textColor,
        primaryHover,
        textHover
    }
}